'use client'

import React from 'react'
import styles from './numericInput.module.scss'

interface NumericInputProps {
  data: any
  value?: number
  onChange?: (value: number) => void
}

const NumericInput = ({ data, value, onChange }: NumericInputProps) => {
  const { label, defaultValue, min, max } = data
  const currentValue = value ?? defaultValue
  // Format to remove leading zeros
  const formattedValue = currentValue != null ? String(currentValue) : ''

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let inputText = e.target.value
    // Remove leading zeros
    if (inputText.length > 1 && inputText.startsWith('0') && !inputText.startsWith('0.')) {
      inputText = inputText.replace(/^0+/, '') || '0'
    }
    const newValue = Number(inputText)
    if (!Number.isNaN(newValue) && newValue <= max && onChange) {
      onChange(newValue)
    }
  }

  return (
    <div className={styles.numericInputContainer}>
      <p className={styles.label}>{label}</p>
      <input
        type="text"
        inputMode="numeric"
        className={styles.input}
        value={formattedValue}
        onChange={handleChange}
        min={min}
        max={max}
      />
    </div>
  )
}

export default NumericInput
